import { useQuery } from '@tanstack/react-query';
import type { CursorPage, TrackedKeyword } from '@seo/types';
import { apiGet } from '@/lib/api';

export function useTrackedKeywords(projectId: string | undefined) {
  return useQuery({
    queryKey: ['tracked-keywords', projectId],
    queryFn: () =>
      apiGet<CursorPage<TrackedKeyword>>(`/v1/tracked-keywords?project_id=${projectId}`),
    enabled: !!projectId,
    placeholderData: (prev) => prev,
  });
}
